import styled from 'styled-components';

export const Screen = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  > div:last-child {
    display: flex;
    flex-direction: row;
  }
`;

export const Table = styled.div`
  border-radius: 8px;
  margin-top: 20px;

  table {
    width: 100%;
    text-align: left;
    border-spacing: 0;
    thead {
      background-color: #f3f7f9;
    }

    tr {
      transition: 0.3s;
      &:hover {
        background-color: #f3f7f9;
      }
    }

    th,
    td {
      padding: 15px;
    }
  }
`;
